/**
 * A helper to get the percentage change when provided with change in value and old value, rounded to two decimal places
 */
export const getPercentageChange = (valueChange: number, oldValue: number): number => {
  if (valueChange === 0 || oldValue === 0) {
    return 0;
  }
  return (valueChange / oldValue) * 100;
};
